import type { ButtonHTMLAttributes, ReactNode } from "react";

import { Icon, type IconName } from "./Icon";
import "./Button.css";

type Variant = "primary" | "ghost" | "danger" | "outline";
type Size = "sm" | "md" | "lg";

type Props = Omit<ButtonHTMLAttributes<HTMLButtonElement>, "className"> & {
  variant?: Variant;
  size?: Size;
  iconLeft?: IconName;
  iconRight?: IconName;
  iconSize?: number;
  className?: string;
  children?: ReactNode;
};

const VARIANT_CLASS: Record<Variant, string> = {
  primary: "btn btn-primary",
  ghost: "btn btn-ghost",
  danger: "btn btn-danger",
  outline: "btn btn-outline",
};

const SIZE_CLASS: Record<Size, string> = { sm: "btn-sm", md: "", lg: "btn-lg" };

export function Button({
  variant = "ghost",
  size = "md",
  iconLeft,
  iconRight,
  iconSize,
  className = "",
  children,
  ...rest
}: Props) {
  const cls = [VARIANT_CLASS[variant], SIZE_CLASS[size], className].filter(Boolean).join(" ");
  const ic = iconSize ?? (size === "sm" ? 13 : size === "lg" ? 16 : 14);
  return (
    <button {...rest} className={cls}>
      {iconLeft && <Icon name={iconLeft} size={ic} />}
      {children}
      {iconRight && <Icon name={iconRight} size={ic} />}
    </button>
  );
}
